import styled from 'styled-components';
import { Colors } from 'enums';

export const IconWrapper = styled.div`
  position: relative;
  height: 24px;
`;

export const IconBubble = styled.div`
  position: absolute;
  height: 7px;
  width: 7px;
  border-radius: 99px;
  border: 1px solid ${Colors.white};
  right: 4px;
  top: 2px;
  background-color: ${Colors.yellow1};
`;
